import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../Common/Axios/axiosIntegration";
export const callEarnPointApi = async (payload) => {
  const { data = {} } = await axiosIntegration.post(API.earnPoints, payload, {
    headers: {
      ClientCode: payload?.ClientCode,
      partnerCode: payload?.partnerCode,
    },
  });
  return data;
};
